<div class="modal-header">
    <h4 class="modal-title">Template Key</h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    @if (loading) {
        <div>Loading template keys...</div>
    } @else {
        <div class="form-group">
            <label for="template-key-input">Template Key</label>
            <mat-form-field appearance="outline" class="template-key-field" subscriptSizing="dynamic">
                <input id="template-key-input" type="text" matInput autocomplete="off"
                    placeholder="Search template keys"
                    [ngModel]="keyInputValue" (ngModelChange)="onKeySearchChange($event)"
                    [matAutocomplete]="auto" />
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayKey" (optionSelected)="onKeySelected($event)">
                    @for (key of filteredTemplateKeys; track key.id) {
                        <mat-option [value]="key">{{key.label}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            @if (isCreatingNew) {
                <small class="form-text text-muted">This will create a new template key "{{keyInputValue.trim()}}".</small>
            }
        </div>

        @if (selectedKey) {
            <div class="form-group">
                @if (!renaming) {
                    <a class="rename-toggle" (click)="startRename()">Rename</a>
                } @else {
                    <label for="template-key-label">New Label</label>
                    <input id="template-key-label" type="text" class="form-control" [(ngModel)]="editedLabel"
                        placeholder="Label" (keyup.enter)="save()" />
                }
            </div>
        }

        @if (errorMessage) {
            <div class="text-danger">{{errorMessage}}</div>
        }
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="loading || saving || !hasValue" (click)="save()">Save</button>
</div>
